import React from "react";
import styles from "./index.module.scss";
import { STATUS_LABELS } from "./types";
export default ({ status }) => (React.createElement("span", { className: `${styles.statusBadge} ${styles[status]}` },
    React.createElement("span", { className: styles.statusDot, "aria-hidden": true }),
    STATUS_LABELS[status]));
